"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityReadingsSummary = FacilityReadingsSummary;
var jsx_runtime_1 = require("react/jsx-runtime");
var facility_dashboard_1 = require("../../../utils/facility-dashboard");
var facility_devices_tile_1 = require("./facility-devices-tile");
var facility_metric_tile_1 = require("./facility-metric-tile");
function FacilityReadingsSummary(props) {
    var _a;
    var summary = props.summary, dateLabel = props.dateLabel, selectedArea = props.selectedArea;
    // Tailwind only emits classes it can see, so the column count is a lookup rather than a template string.
    var COLUMN_CLASSES = {
        1: "lg:grid-cols-1",
        2: "lg:grid-cols-2",
        3: "lg:grid-cols-3",
        4: "lg:grid-cols-4",
        5: "lg:grid-cols-5",
        6: "lg:grid-cols-6",
    };
    var tiles = (0, facility_dashboard_1.buildMetricTiles)(summary, dateLabel, selectedArea);
    var tileCount = tiles.length + 1;
    var columns = (_a = COLUMN_CLASSES[Math.min(tileCount, 6)]) !== null && _a !== void 0 ? _a : COLUMN_CLASSES[6];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 sm:grid-cols-2 ".concat(columns, " gap-4"), children: [(0, jsx_runtime_1.jsx)(facility_devices_tile_1.FacilityDevicesTile, { devices: summary.devices, onlineDevices: summary.onlineDevices, totalDevices: summary.totalDevices }), tiles.map(function (tile) { return ((0, jsx_runtime_1.jsx)(facility_metric_tile_1.FacilityMetricTile, { tile: tile }, tile.key)); })] }));
}
